import { DeleteSquareIcon } from '@/assets/icons';
import { memo } from 'react';

import { AnyObject } from 'yup';

import { DefineDocumentWriteButton } from '..';
import Button from '../common/button';
import {
	DefineDocumentWriteModeEnum,
	PayloadUploaded,
} from '../define-document-write/define-document-write.type';

type ActionsDocumentProps = {
	record: AnyObject;
	onDeleteDocument: (id: number) => void;
	onUploaded(data: PayloadUploaded): void;
	selectedRowKeys: React.Key[];
	onSelectDocument: (record: AnyObject) => void;
	refTableId: number;
};

const ActionsDocument = ({
	record,
	onDeleteDocument,
	onUploaded,
	selectedRowKeys,
	onSelectDocument,
	refTableId,
}: ActionsDocumentProps) => {
	const { fileName, id, hasDocument, refTableName } = record || {};

	return (
		<>
			{fileName ? (
				<div className="flex items-center gap-[10px]">
					<span className="break-all w-full flex-1 text-left text-[13px] text-font2">
						{fileName}
					</span>
					<DeleteSquareIcon
						className="cursor-pointer "
						onClick={() => onDeleteDocument(id)}
						width={12}
						height={12}
					/>
				</div>
			) : (
				<div className="text-left">
					{selectedRowKeys.length ? (
						<Button
							className="!w-[43px] min-w-0"
							secondary
							onClick={() => onSelectDocument(record)}
						>
							선택
						</Button>
					) : (
						!hasDocument && '-'
					)}
				</div>
			)}
			{/* Always render DefineDocumentWriteButton outside conditions to prevent unmount */}
			<div
				className="text-left"
				style={{
					display:
						fileName || !hasDocument || selectedRowKeys.length > 0
							? 'none'
							: 'block',
				}}
			>
				<DefineDocumentWriteButton
					key={`write-button-${id}`}
					label="작성"
					documentType={record.documentType}
					className="!w-[43px] min-w-0"
					rowId={id}
					onUploaded={onUploaded}
					refTableName={refTableName}
					mappingList={record.mappingList}
					mode={DefineDocumentWriteModeEnum.CREATE}
					refTableId={refTableId}
				/>
			</div>
		</>
	);
};

export default memo(ActionsDocument);
